import { render, staticRenderFns } from "./appConfigEdit.vue?vue&type=template&id=f9efa088&scoped=true"
import script from "./appConfigEdit.vue?vue&type=script&lang=js"
export * from "./appConfigEdit.vue?vue&type=script&lang=js"
import style0 from "./appConfigEdit.vue?vue&type=style&index=0&id=f9efa088&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f9efa088",
  null
  
)

export default component.exports